/**
 * Web Badging API helpers - show an unread count on the installed app icon.
 * Supported on installed PWAs: Android (Chrome), desktop (Chrome/Edge), and
 * iOS 16.4+ Home Screen web apps. No-ops everywhere else.
 */
export function setAppBadge(count: number): void {
  try {
    const nav = navigator as any;
    if (typeof nav.setAppBadge === 'function') {
      if (count > 0) nav.setAppBadge(count);
      else if (typeof nav.clearAppBadge === 'function') nav.clearAppBadge();
    }
  } catch {
    /* best-effort */
  }
}

export function clearAppBadge(): void {
  try {
    const nav = navigator as any;
    if (typeof nav.clearAppBadge === 'function') nav.clearAppBadge();
  } catch {
    /* best-effort */
  }
}
